export function extractPath(url) {
  try {
    const parsed = new URL(url);
    return parsed.pathname + parsed.search + parsed.hash || '/';
  } catch {
    return url.startsWith('/') ? url : '/';
  }
}
